import { ITicketStatusAction } from '../actions/update-ticket-summary';
import { ITicketsState } from '../state';

export type UpdateTicketSummaryAction
    = ITicketStatusAction;

const update = (state: ITicketsState, action: UpdateTicketSummaryAction) => ({
    ...state,
    ticketStatus: action.ticketStatus
});

export const updateTicketSummaryReducer = (state, action) => update(state, action);
